import { longImageDisplayName } from "@/entities/work/model/longImageName";

/**
 * 海报转视频横幅「海报「X」」里的 X(1006 演示机复测)。
 *
 * 现象:从一键长图点「据这张图编一部片」,横幅写「海报「…」」——名字是空的。
 * 根因:横幅只认 `from-poster` 装配响应的 `title`,那是海报**内容**里的标题(api
 *   `VideoFromPosterService` 按占位词判空、长图再退首屏 overlayText);一键长图两样都可能没有 → null。
 * 修法:内容标题取不到就退回**作品名**(「我的作品」卡上那个名字),长图名按 `longImageDisplayName`
 *   去掉「一键长图·企业介绍长图·」只留「主题·时间」,与作品卡 / 任务详情页同口径。都没有 → null(横幅照旧「…」)。
 */
export function posterBannerTitle(
  contentTitle: string | null | undefined,
  workName: string | null | undefined
): string | null {
  const c = (contentTitle ?? "").trim();
  if (c) return c;
  return longImageDisplayName(workName) || null;
}
